import {connect} from 'react-redux';

import {MessageModel} from '../../../../../libs/shared/core/src/models/api/messageModel';
import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {
  makeGetAiReplyFactForMessage,
  makeGetLingeringRuleForConversation,
  makeGetMacrosForConversation,
} from '../../../../store/data/macros/macroSelectors';
import {makeGetMessageConversation} from '../../../../store/data/messages/messagesSelectors';
import {MacroTriggers} from './macroTriggers';

interface MacroTriggersContainerProps {
  message: MessageModel;
}

function getMessage(_state: AppState, props: MacroTriggersContainerProps) {
  return props.message;
}

function getConversationId(_state: AppState, props: MacroTriggersContainerProps) {
  return props.message.conversationId;
}

const mapStateToProps = makeMapStateToProps<MacroTriggersContainerProps>()(() => {
  const getConversation = makeGetMessageConversation(getMessage);
  const getMacros = makeGetMacrosForConversation(getConversation);
  const getLingeringRule = makeGetLingeringRuleForConversation(getConversation);
  const getAiReply = makeGetAiReplyFactForMessage(getMessage);

  return {
    conversationId: getConversationId,
    macros: getMacros,
    lingeringRule: getLingeringRule,
    aiReply: getAiReply,
  };
});

export const MacroTriggersContainer = connect(mapStateToProps)(MacroTriggers);
